module.exports = {"TXTCLI_Final":{"id":"TXTCLI_Final","defaultMessage":"Фінал"},"TXTCLI_Tournament":{"id":"TXTCLI_Tournament","defaultMessage":"Турнір"}}